export default __webpack_public_path__ + "static/media/ethertheft.ab7d9e18.png";